(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-personalizacion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-quote')) {
    class AtelierQuote extends HTMLElement {
      connectedCallback() {
        if (this._form) return;
        this._form = this.querySelector('[data-quote-form]');
        if (!this._form) return;
        this._onSubmit = (event) => {
          if (!this._form.checkValidity()) {
            event.preventDefault();
            this._form.reportValidity();
            return;
          }
          const lines = [this.dataset.greeting, ''];
          this._form.querySelectorAll('[data-field]').forEach((field) => {
            const value = field.value.trim();
            if (value) lines.push(field.dataset.label + ': ' + value + (field.dataset.unit ? ' ' + field.dataset.unit : ''));
          });
          if (this.dataset.productUrl) lines.push('', this.dataset.urlLabel + ': ' + this.dataset.productUrl);
          this.querySelector('[data-message]').value = lines.join('\n');
        };
        this._form.addEventListener('submit', this._onSubmit);
        this._form.hidden = false;
        const fallback = this.querySelector('[data-quote-fallback]');
        if (fallback) fallback.hidden = true;
      }
      disconnectedCallback() {
        if (this._form && this._onSubmit) this._form.removeEventListener('submit', this._onSubmit);
        this._form = null;
      }
    }
    customElements.define('atelier-quote', AtelierQuote);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
